/* eslint-disable */

import { axiosInstanceLive } from 'instance/Axios';
import { handleCatchError } from 'utils/CatchHandler';

const commonEndPoint = 'api/V2/';
const latitude = localStorage.getItem('latitude');
const longitude = localStorage.getItem('longitude');
let merchantEmpID;
const isEmployee = localStorage.getItem('isEmployee');
if (isEmployee === 'true') {
    merchantEmpID = localStorage.getItem('empId');
}
export const commonPost = async (apiEndPoint, payload, params) => {
    const endPoint = commonEndPoint + apiEndPoint;
    const token = localStorage.getItem('token');
    const isFormData = payload instanceof FormData;
    const headers = {
        Authorization: `Bearer ${token}`,
        'Header-Merchant-Employee': merchantEmpID,
        ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
        'X-Latitude': latitude,
        'X-Longitude': longitude
    };
    try {
        const response = await axiosInstanceLive.post(
            endPoint,
            payload,

            {
                headers,
                params
            }
        );
        return response;
    } catch (error) {
        console.log(error);
        handleCatchError(error);
        return error;
    }
};
export const commonGetRequest = async (apiEndPoint, params) => {
    const endPoint = commonEndPoint + apiEndPoint;
    const token = localStorage.getItem('token');
    const headers = {
        Authorization: `Bearer ${token}`,
        'Header-Merchant-Employee': merchantEmpID,
        'Content-Type': 'application/json',
        'X-Latitude': latitude,
        'X-Longitude': longitude
    };
    try {
        const response = await axiosInstanceLive.get(
            endPoint,

            {
                headers,
                params
            }
        );
        return response;
    } catch (error) {
        console.log(error);
        handleCatchError(error);
        return error;
    }
};
const handleApiRequest = async (method, endpoint, payload = null) => {
    try {
        const response =
            method === 'GET'
                ? await commonGetRequest(endpoint, payload) // Pass params for GET
                : await commonPost(endpoint, payload); // Pass body for POST

        return response;
    } catch (error) {
        console.error('API Error:', error);
        return null;
    }
};
export const GET_API_ENDPOINTS = {
    getBalance: 'moneytransfer/superDistributor/balance',
    getApproveWallet: 'moneytransfer/superDistributor/list/Approvewalletrequest',
    getAddBankDetails: 'moneytransfer/superDistributor/addBankDetails',
    // deleteBankDetails: 'moneytransfer/superDistributor/deleteBankDetails',
    getAddress: 'moneytransfer/address_details',
    listDistributor: 'moneytransfer/superDistributor/listdistributor',
    getProfile: 'moneytransfer/superDistributor/profile',
    walletRequests: 'moneytransfer/superDistributor/walletrequest',
    listdistributor: 'moneytransfer/superDistributor/listdistributor',
    getMccForDistributor: 'moneytransfer/superDistributor/Mcccodes',
    verifyPan: 'moneytransfer/superDistributor/verifyPancard',
    verifyBank: 'moneytransfer/superDistributor/verifyBank',
    verifyAadhaar: 'moneytransfer/superDistributor/verifyAdhaar',
    getDistrict: 'moneytransfer/superDistributor/district',
    getState: 'moneytransfer/superDistributor/states',
    getMcc: 'moneytransfer/superDistributor/mcc',
    getBussiness: 'moneytransfer/superDistributor/business',
    getCity: 'moneytransfer/superDistributor/fetchCity',
    getBank: 'moneytransfer/superDistributor/fetchBank',
    selectAllEmployee: 'moneytransfer/superDistributor/selectAllEmployees',
    listAllMerchants: 'moneytransfer/superDistributor/listAllMerchants',
    listSubdistributors: 'moneytransfer/superDistributor/listSubdistributor'
};
export const POST_API_ENDPOINTS = {
    approveWalletRequest: 'moneytransfer/superDistributor/ApproveWalletrequest',
    rejectWalletRequest: 'moneytransfer/superDistributor/RejectWalletrequest',
    updateBankDetails: 'moneytransfer/superDistributor/updateBankDetails',
    storeBankDetails: 'moneytransfer/superDistributor/storeBankDetails',
    storeDistributor: 'moneytransfer/superDistributor/StoredetailsDistributor',
    viewDistributor: 'moneytransfer/superDistributor/viewdistributor',
    debitBalance: 'moneytransfer/superDistributor/DebitbalancefromDistributor',
    AgentDebitBalance: 'moneytransfer/superDistributor/DebitbalancefromAgents',
    editDistributor: 'moneytransfer/superDistributor/editdistributor',
    editDetailsDistributor: 'moneytransfer/superDistributor/EditdetailsDistributor',
    listMerchant: 'moneytransfer/superDistributor/listmerchants',
    resetPassword: 'moneytransfer/superDistributor/Setresetpassword',
    listMerchants: 'moneytransfer/superDistributor/listtxnmerchants',
    qrWalletTransfer: 'moneytransfer/superDistributor/GetQrwallettransfer',
    storeWalletRequest: 'moneytransfer/superDistributor/StoreDetailsWalletrequest',
    listMerchantInDistributor: 'moneytransfer/superDistributor/listMerchantInDistributor',
    allTransaction: 'moneytransfer/superDistributor/allTransaction',
    emailOtp: 'moneytransfer/superDistributor/sendEmailOtp',
    emailOtpVerify: 'moneytransfer/superDistributor/VerifyEmailOTP',
    onboard: 'moneytransfer/superDistributor/StoreagentdetailsNew',
    qronboard: 'moneytransfer/superDistributor/onboard/QrOnboarding',
    posOnboard: 'moneytransfer/superDistributor/onboard/PosOnboarding',
    Aeps: 'moneytransfer/superDistributor/storeAepsDetails',
    changeTm: 'moneytransfer/superDistributor/onchangeTm',
    changeTl: 'moneytransfer/superDistributor/onchangeTl',
    mapping: 'moneytransfer/superDistributor/UpdateMerchantEmployeeMapping',
    ResendOTP: 'moneytransfer/superDistributor/ResendOTP',
    VerifyOTP: 'moneytransfer/superDistributor/VerifyOTP',
    getAllonboarded: 'moneytransfer/superDistributor/merchantsList',
    viewMerchant: 'moneytransfer/superDistributor/viewMerchant',
    listAllmerchants: 'moneytransfer/superDistributor/listAllmerchants',
    allbc: 'moneytransfer/superDistributor/listBc',
    viewMerchantDetails: 'moneytransfer/superDistributor/viewMerchantDetails',
    merchantTransactions: 'moneytransfer/superDistributor/view/MerchantTransactions',
    ssoBcDashboard: 'moneytransfer/superDistributor/sso/AgentLogin',
    ConvertAsAgent: 'moneytransfer/superDistributor/onboard/ConvertAsAgent',
    listmytransactions: 'moneytransfer/superDistributor/listmytransactions',
    deleteBankDetails: 'moneytransfer/superDistributor/deleteBankDetails',
    soundBox: 'moneytransfer/superDistributor/soundbox/activation',
    listSoundBox: 'moneytransfer/superDistributor/soundbox/get-details',
    StoredetailsSubDistributor: 'moneytransfer/superDistributor/StoredetailsSubDistributor',
    viewSubdistributor: 'moneytransfer/superDistributor/viewSubdistributor',
    editSubdistributor: 'moneytransfer/superDistributor/EditdetailsSubDistributor',
    creditToDist: 'moneytransfer/superDistributor/CreditbalancetoDistributor',
    checkPermission: 'moneytransfer/superDistributor/checkPermission',
    superdistLeadlist: 'moneytransfer/superDistributor/SuperdistLeadlist',
    creditLeadCommission: 'moneytransfer/superDistributor/SuperdistLeadlist/CustomercommissionCredit',
    qrStatusChecker: 'moneytransfer/superDistributor/indexQrOnboarding',
    IncentiveReportList: 'moneytransfer/superDistributor/ListcheckBCExport',
    graphData: 'moneytransfer/superDistributor/graphData',
    signSDistAgreement: 'moneytransfer/superDistributor/sign-SDistAgreement',
    getSDistAgreement: 'moneytransfer/superDistributor/get-SDistAgreement',
    listBcSettlements: 'moneytransfer/superDistributor/listBcSettlements',
    listAllSettlements: 'moneytransfer/superDistributor/listAllSettlements',
    StoreSettlements: 'moneytransfer/superDistributor/StoreSettlements',
    callToAgents: 'moneytransfer/superDistributor/Calltoagents',
    aadharValidation: 'moneytransfer/superDistributor/aadharValidateStep1',
    aadharValidateOtp: 'moneytransfer/superDistributor/aadharValidateStep2',
    serviceList: 'moneytransfer/superDistributor/report-list',
    listAllEmployees: 'moneytransfer/superDistributor/ListAllEmployees',
    CreateEmployee: 'moneytransfer/superDistributor/CreateEmployee',
    ListSdEmployee: 'moneytransfer/superDistributor/ListEmployee',
    EditEmployee: 'moneytransfer/superDistributor/EditEmployee',
    AddFundstoEmployee: 'moneytransfer/superDistributor/AddFundstoEmployee',
    LedgerEmployee: 'moneytransfer/superDistributor/LedgerEmployee',
    setMdrCharges: 'moneytransfer/superDistributor/Setcharges/Mdr',
    ListAllBatches: 'moneytransfer/superDistributor/ListAllBatches',
    UpdatestatusBatches: 'moneytransfer/superDistributor/UpdatestatusBatches',
    allTransactionSdAdmin: 'moneytransfer/superDistributor/allTransactionMuthoot',
    createDistributorApi: 'moneytransfer/superDistributor/StoredetailsDistributorV2',
    listBranchRequestsAdmin: 'moneytransfer/superDistributor/listMuthootRequests',
    viewBranchProfile: 'moneytransfer/superDistributor/indexeditmerchants',
    storeEditMerchants: 'moneytransfer/superDistributor/StoreEditmerchants',
    monthlyAnalysis: 'moneytransfer/superDistributor/listMuthootBranchTargets',
    listAllDistEmployee: 'moneytransfer/superDistributor/ListAllDistEmployees',
    enableDisableEmp: 'moneytransfer/superDistributor/EnableDisableEmp',
    SettlementStatusUpdate: 'moneytransfer/superDistributor/Update/SettlementStatus',
    listTxnDetails: 'moneytransfer/superDistributor/quicklypay/listTxnDetails',
    getTransactions: 'moneytransfer/superDistributor/quicklypay/getTransactions',
    changeStatus: 'moneytransfer/superDistributor/quicklypay/statusChange',
    editSuperDist: 'moneytransfer/superDistributor/EditdetailsDistributorV2',
    //Quickly pay special dashboard apis starts here>>>>
    createClient: 'moneytransfer/superDistributor/quicklypay/createClient',
    listClient: 'moneytransfer/superDistributor/quicklypay/listClient',
    updateClient: 'moneytransfer/superDistributor/quicklypay/updateClient',
    createVendor: 'moneytransfer/superDistributor/quicklypay/createVendor',
    listVendor: 'moneytransfer/superDistributor/quicklypay/listVendor',
    updateVendor: 'moneytransfer/superDistributor/quicklypay/updateVendor',
    listServiceProvider: 'moneytransfer/superDistributor/quicklypay/listServiceProvider',
    updateServiceProvider: 'moneytransfer/superDistributor/quicklypay/updateServiceProvider',
    createServiceProvider: 'moneytransfer/superDistributor/quicklypay/createServiceProvider',
    dailyTxnUpload: 'moneytransfer/superDistributor/quicklypay/dailyTxnUpload',
    dailyTxnUploadHistory: 'moneytransfer/superDistributor/quicklypay/dailyTxnUploadHistory',
    dailyTxnList: 'moneytransfer/superDistributor/quicklypay/dailyTxnList',
    dailyTxnHistroyUpdate: 'moneytransfer/superDistributor/quicklypay/dailyTxnHistroyUpdate',
    vendorTxnUpload: 'moneytransfer/superDistributor/quicklypay/vendorTxnUpload',
    vendorTxnList: 'moneytransfer/superDistributor/quicklypay/vendorTxnList',
    vendorTxnHistroyUpdate: 'moneytransfer/superDistributor/quicklypay/vendorTxnHistroyUpdate',
    getDashboard: 'moneytransfer/superDistributor/quicklypay/getDashboard',
    trialBalance: 'moneytransfer/superDistributor/quicklypay/trialBalance',
    leadgerList: 'moneytransfer/superDistributor/quicklypay/leadgerList',
    deleteDailyTxnData: 'moneytransfer/superDistributor/quicklypay/deleteDailyTxnData',
    digiloan: 'moneytransfer/superDistributor/digiloan/addUser',
    listLoan: 'moneytransfer/superDistributor/digiloan/userList',
    BCPhysicalVerificationSD: 'moneytransfer/superDistributor/BCPhysicalVerification',
    BCPhysicalVerificationSendEmail: 'moneytransfer/superDistributor/BCPhysicalVerification/SendEmail'

    //Quickly pay special dashboard apis ends here<<<<<
};
export const getBalanceApi = (params) => handleApiRequest('GET', GET_API_ENDPOINTS.getBalance, params);
export const getApproveWallet = (params) => handleApiRequest('GET', GET_API_ENDPOINTS.getApproveWallet, params);
export const fetchApproveWalletRequest = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.approveWalletRequest, payload);
export const fetchRejectWalletRequest = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.rejectWalletRequest, payload);
export const getAddBankDetails = (params) => handleApiRequest('GET', GET_API_ENDPOINTS.getAddBankDetails, params);
export const updateBankDetails = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.updateBankDetails, payload);
export const deleteBankDetails = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.deleteBankDetails, payload);
export const storeBankDetails = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.storeBankDetails, payload);
export const getAddress = (params) => handleApiRequest('GET', GET_API_ENDPOINTS.getAddress, params);
export const storeDistributor = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.storeDistributor, payload);
export const viewDistributors = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.viewDistributor, payload);
export const fetchDebitBalance = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.debitBalance, payload);
export const fetchAgentDebitBalance = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.AgentDebitBalance, payload);
export const getListDistributor = (params) => handleApiRequest('GET', GET_API_ENDPOINTS.listDistributor, params);
export const editDistributor = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.editDistributor, payload);
export const editDetailsDistributor = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.editDetailsDistributor, payload);
export const listMerchant = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.listMerchant, payload);
export const getProfileApi = (params) => handleApiRequest('GET', GET_API_ENDPOINTS.getProfile, params);
export const resetPassword = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.resetPassword, payload);
export const listMerchants = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.listMerchants, payload);
export const qrWalletTransfer = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.qrWalletTransfer, payload);
export const walletRequests = (params) => handleApiRequest('GET', GET_API_ENDPOINTS.walletRequests, params);
export const storeWalletRequest = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.storeWalletRequest, payload);
export const listMerchantInDist = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.listMerchantInDistributor, payload);
export const allTransactions = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.allTransaction, payload);
export const ssoBcDashboardApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.ssoBcDashboard, payload);
export const ConvertAsAgentApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.ConvertAsAgent, payload);
export const listmytransactionsApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.listmytransactions, payload);
export const listdistributor = (params) => handleApiRequest('GET', GET_API_ENDPOINTS.listdistributor, params);
export const getVerifyPanApi = (params) => handleApiRequest('GET', GET_API_ENDPOINTS.verifyPan, params);
export const listSubdistributorsApi = (params) => handleApiRequest('GET', GET_API_ENDPOINTS.listSubdistributors, params);
export const checkPermissionApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.checkPermission, payload);
export const getVerifyBank = (params) => handleApiRequest('GET', GET_API_ENDPOINTS.verifyBank, params);
export const getVerifyAadhaar = (params) => handleApiRequest('GET', GET_API_ENDPOINTS.verifyAadhaar, params);
export const getDistrictApi = (params) => handleApiRequest('GET', GET_API_ENDPOINTS.getDistrict, params);
export const getStateApi = (params) => handleApiRequest('GET', GET_API_ENDPOINTS.getState, params);
export const getMccApi = (params) => handleApiRequest('GET', GET_API_ENDPOINTS.getMcc, params);
export const getBussinessApi = (params) => handleApiRequest('GET', GET_API_ENDPOINTS.getBussiness, params);
export const getCityApi = (params) => handleApiRequest('GET', GET_API_ENDPOINTS.getCity, params);
export const getEmailOtp = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.emailOtp, payload);
export const getEmailOtpVErify = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.emailOtpVerify, payload);
export const onboardApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.onboard, payload);
export const getBankApi = (params) => handleApiRequest('GET', GET_API_ENDPOINTS.getBank, params);
export const qronboardApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.qronboard, payload);
export const posOnboardApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.posOnboard, payload);
export const AepsApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.Aeps, payload);
export const resendOtpApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.ResendOTP, payload);
export const verifyOtpApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.VerifyOTP, payload);
export const getListAllMerchants = (params) => handleApiRequest('GET', GET_API_ENDPOINTS.listAllMerchants, params);
export const getAllOnboardedApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.getAllonboarded, payload);
export const getMerchantViewApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.viewMerchant, payload);
export const listAllMerchantsApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.listAllmerchants, payload);
export const listAllBc = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.allbc, payload);
export const viewMerchantDetails = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.viewMerchantDetails, payload);
export const transactionMerchant = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.merchantTransactions, payload);
export const AddSoundBoxApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.soundBox, payload);
export const getListSoundBox = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.listSoundBox, payload);
export const StoredetailsSubDistributorApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.StoredetailsSubDistributor, payload);
export const getIncentiveReportList = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.IncentiveReportList, payload);
export const getserviceList = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.serviceList, payload);
export const viewSubdistributorApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.viewSubdistributor, payload);
export const editSubdistributorApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.editSubdistributor, payload);
export const creditToDist = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.creditToDist, payload);
export const statusCheckerApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.qrStatusChecker, payload);
export const graphDataApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.graphData, payload);
export const signSDistAgreementApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.signSDistAgreement, payload);
export const getSDistAgreementApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.getSDistAgreement, payload);
export const listBcSettlementsApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.listBcSettlements, payload);
export const listAllSettlementsApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.listAllSettlements, payload);
export const storeSettlementsApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.StoreSettlements, payload);
export const callToAgentApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.callToAgents, payload);
export const aadharValidateApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.aadharValidation, payload);
export const aadharValidateOtpApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.aadharValidateOtp, payload);
export const listAllEmployeeApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.listAllEmployees, payload);
export const createEmployeeApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.CreateEmployee, payload);
export const updateEmployeeApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.EditEmployee, payload);
export const AddFundstoEmployeeApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.AddFundstoEmployee, payload);
export const LedgerEmployeeApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.LedgerEmployee, payload);
export const setMdrChargesApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.setMdrCharges, payload);
export const ListAllBatchesApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.ListAllBatches, payload);
export const UpdatestatusBatchesApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.UpdatestatusBatches, payload);
export const allTransactionSdAdminApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.allTransactionSdAdmin, payload);
export const createDistributorApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.createDistributorApi, payload);
export const listBranchRequestsAdminApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.listBranchRequestsAdmin, payload);
export const viewBranchProfileApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.viewBranchProfile, payload);
export const storeEditMerchantsApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.storeEditMerchants, payload);
export const monthlyAnalysisApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.monthlyAnalysis, payload);
export const listAllDistEmployeeApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.listAllDistEmployee, payload);
export const enableDisableEmpApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.enableDisableEmp, payload);
export const settlementStatusUpdateApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.SettlementStatusUpdate, payload);
export const fundTransferReportApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.listTxnDetails, payload);
export const getTransactionsApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.getTransactions, payload);
export const statusChangerApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.changeStatus, payload);
export const editSuperDistributorApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.editSuperDist, payload);
export const createClientApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.createClient, payload);
export const listClientApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.listClient, payload);
export const updateClientApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.updateClient, payload);
export const createVendorApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.createVendor, payload);
export const listVendorApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.listVendor, payload);
export const updateVendorApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.updateVendor, payload);
export const listServiceProviderApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.listServiceProvider, payload);
export const createServiceProviderApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.createServiceProvider, payload);
export const updateServiceProviderApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.updateServiceProvider, payload);
export const dailyTxnUploadApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.dailyTxnUpload, payload);
export const dailyTxnUploadHistoryApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.dailyTxnUploadHistory, payload);
export const dailyTxnListApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.dailyTxnList, payload);
export const dailyTxnHistroyUpdateApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.dailyTxnHistroyUpdate, payload);
export const vendorTxnUploadApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.vendorTxnUpload, payload);
export const vendorTxnListApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.vendorTxnList, payload);
export const vendorTxnHistroyUpdateApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.vendorTxnHistroyUpdate, payload);
export const getDashboardStatisticsApi = (payload) => handleApiRequest('GET', POST_API_ENDPOINTS.getDashboard, payload);
export const trialBalanceApi = (payload) => handleApiRequest('GET', POST_API_ENDPOINTS.trialBalance, payload);
export const moneyFlowLegderApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.leadgerList, payload);
export const deleteDailyTxnDataApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.deleteDailyTxnData, payload);
export const ListSdEmployeeApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.ListSdEmployee, payload);
export const digiLoanForm = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.digiloan, payload);
export const digiLoanList = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.listLoan, payload);
export const superdistLeadlist = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.superdistLeadlist, payload);
export const creditLeadCommission = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.creditLeadCommission, payload);
export const BCPhysicalVerificationSD = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.BCPhysicalVerificationSD, payload);
export const BCPhysicalVerificationSendEmail = (payload) =>
    handleApiRequest('POST', POST_API_ENDPOINTS.BCPhysicalVerificationSendEmail, payload);
//Quickly pay special dashboard apis ends here<<<<
